export class Pin {

    constructor() {
    }

    public blocked: boolean;
    public lastTry: boolean;
    public remainingTries: number;
}
